var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    fill: "none",
    className: "quotes_svg__quotes"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M53.23 9.125c9.239 0 16.728 7.49 16.728 16.73 0 6.823-3.552 13.426-8.854 14.7-2.046.492-3.674 3.117-3.324 6.113.468 4.01 4.095 8.062 11.275 11.255 1.6.71.93 3.116-.806 2.899C49.535 58.479 36.563 46.278 36.5 29.017c0-11.871 7.014-19.892 16.73-19.892m-36.501 0c9.24 0 16.73 7.49 16.73 16.73 0 6.823-3.553 13.426-8.856 14.7-2.045.492-3.674 3.117-3.324 6.113.469 4.01 4.096 8.062 11.276 11.255 1.599.71.93 3.116-.807 2.899C13.034 58.479.062 46.278 0 29.017 0 17.146 7.013 9.125 16.729 9.125"
  })));
};
export default SvgQuotes;